// Mirrors backstage-service-sonarqube's Models/Validation.cs and SetupServiceGroupRequest.cs,
// so invalid input is caught before the request instead of as a 400.
const applicationKeyPattern =
  /^[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*_[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*$/;
const displayNamePattern = /^[\p{L}\p{N} ._:()-]+$/u;
const singleLinePattern = /^[^\p{C}]*$/u;

/** `{team}_` prefill for the application key: the team slug without characters a key part can't hold. */
export const applicationKeyPrefix = (teamSlug: string) =>
  `${teamSlug
    .toLowerCase()
    .replace(/[^a-z0-9.-]/g, '')
    .replace(/\.{2,}/g, '.')
    .replace(/^\.|\.$/g, '')}_`;

export const isValidApplicationKey = (key: string) =>
  key.length <= 100 && applicationKeyPattern.test(key);

export const isValidApplicationName = (name: string) =>
  name.length <= 255 && displayNamePattern.test(name);

export const isValidApplicationDescription = (description: string) =>
  description.length <= 256 && singleLinePattern.test(description);
